import { gpt } from "@/utils/urlConstants";

export default ({ post }) => ({
  // Errors are rejected as the response body (see plugins/axios.js), so callers read `err.error`.
  createEmbedSession() {
    return post(gpt.embedSession, {});
  },
});
